import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import airplaneClockIcon from '@iconify/icons-mdi/airplane-clock';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import moment from 'moment';
import { useTranslation } from '../../../common/LocalizationProvider';
import { fNumber } from '../../../common/utils/formatNumber';

// utils

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.success.darker,
  backgroundColor: theme.palette.success.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.success.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.success.dark, 0)} 0%, ${alpha(
    theme.palette.success.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

AppVolHours.propTypes = {
  summary: PropTypes.array
};

export default function AppVolHours({ summary }) {
  const t = useTranslation();

  const hours = moment
    .duration(
      summary.reduce((sum, item) => {
        sum += item.engineHours;
        return sum;
      }, 0)
    )
    .asHours()
    .toFixed(0);

  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={airplaneClockIcon} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{`${fNumber(hours)} h`}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {t('DB_Flight_STime')}
      </Typography>
    </RootStyle>
  );
}
